import * as RP from "@radix-ui/react-progress";
import clsx from "clsx";

export type ProgressBarProps = {
  value?: number | null;
  max?: number;
  label?: string;
  showValue?: boolean;
  size?: "sm" | "md";
  tone?: "brand" | "success" | "warning" | "danger";
  className?: string;
};

const sizeMap = { sm: "h-1", md: "h-2" };
const toneMap = {
  brand:   "bg-[var(--color-accent)]",
  success: "bg-[var(--color-success-500)]",
  warning: "bg-[var(--color-warning-500)]",
  danger:  "bg-[var(--color-danger-500)]",
};

export function ProgressBar({ value, max = 100, label, showValue, size = "md", tone = "brand", className }: ProgressBarProps) {
  const pct = value == null ? null : Math.max(0, Math.min(100, (value / max) * 100));
  const indeterminate = pct == null;
  return (
    <div className={clsx("flex flex-col gap-1", className)}>
      {(label || showValue) && (
        <div className="flex items-center justify-between text-xs">
          {label && <span className="text-[var(--color-text-primary)]">{label}</span>}
          {showValue && pct != null && <span className="text-[var(--color-text-secondary)]">{pct.toFixed(0)}%</span>}
        </div>
      )}
      <RP.Root
        value={pct}
        max={100}
        className={clsx("relative w-full overflow-hidden rounded-full bg-[var(--color-surface-muted)]", sizeMap[size])}
      >
        <RP.Indicator
          className={clsx(
            "h-full transition-transform duration-500",
            toneMap[tone],
            indeterminate && "animate-pulse",
          )}
          style={{ transform: indeterminate ? "translateX(-30%)" : `translateX(-${100 - (pct ?? 0)}%)` }}
        />
      </RP.Root>
    </div>
  );
}
